import { render, staticRenderFns } from "./ItemInfoTable.vue?vue&type=template&id=6a3c187e&scoped=true"
import script from "./ItemInfoTable.vue?vue&type=script&lang=js"
export * from "./ItemInfoTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a3c187e",
  null
  
)

export default component.exports